"use client";

import { useAppRouter } from "@/src/shared/hooks/useAppRouter";
import { type IFilter } from "@/src/shared/features/search";
import { useListingPriceQuery } from "../api/queries";
import { listingService } from "../services";

/** Price of the listing in the URL for the selected stay. */
const useListingPrice = (filters: IFilter) => {
  const router = useAppRouter();
  const listingId = listingService.listingIdFromRoute(
    router.query,
    router.asPath,
  );
  const { data, isLoading, error } = useListingPriceQuery(
    listingService.buildPriceParams(filters, listingId),
  );

  return {
    data: data ?? null,
    loading: isLoading,
    error: error ? error.message : null,
  };
};

export default useListingPrice;
